(ns dre.components.button
  (:require
   [dre.utils.bem :as bem-utils]))

(def component-name :button)

(defn- bm
  [m]
  (bem-utils/bm component-name m))

(defn button
  ([content]
   [button {} content])
  ([{:keys [size type disabled? on-click]} content]
   [:button
    {:on-click (or on-click (constantly nil))
     :class [component-name
             (case size
               :medium (bm :medium)
               :small (bm :small)
               nil)
             (case type
               :brand (bm :brand)
               :light (bm :light)
               :bare (bm :bare)
               :danger (bm :danger)
               nil)
             (when disabled?
               (bm :disabled))]}
    content]))
